import { configureStore } from "@reduxjs/toolkit";
import userInformationReducer from "../slices/userSlice";
import collectionSliceReducer from "../slices/collectionSlice";
import languageSliceReducer from "../slices/languageSlice";
import newsSliceReducer from "../slices/newsSlice";
import gamesSliceReducer from "../slices/gamesSlice";
import affiliateSliceReducer from "../slices/affiliateSlice";
import codexSliceReducer from "slices/codexSlice";

const store = configureStore({
  reducer: {
    collectionSlice: collectionSliceReducer,
    userSlice: userInformationReducer,
    languageSlice: languageSliceReducer,
    newsSlice: newsSliceReducer,
    gamesSlice: gamesSliceReducer,
    affiliateSlice: affiliateSliceReducer,
    codexSlice: codexSliceReducer,
  },
});

export default store;

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
